export const createProductFields = (element) => {
  if (!element || element.length === 0) {
    return null;
  }

  const instance = {
    $element: null,
    $form: null,
    fields: [],

    init: function (element) {
      this.$element = jQuery(element);
      this.fields = this.$element.find("input[required]").toArray();

      if (this.fields.length) {
        this.setupEventListeners();
      }
    },

    setupEventListeners: function () {
      this.fields.forEach((field) => {
        jQuery(field).on("input", (e) => {
          this.validateField(e.target);
        });
      });
    },

    validateField: function (field) {
      const $field = jQuery(field);
      if (!$field.val().trim()) {
        $field
          .addClass("border-red-500 bg-red-50")
          .removeClass("border-gray-300");
        return false;
      }
      $field
        .removeClass("border-red-500 bg-red-50")
        .addClass("border-gray-300");
      return true;
    },

    validate: function () {
      let valid = true;
      this.fields.forEach((field) => {
        const $field = jQuery(field);
        valid = this.validateField($field);
      });
      return valid;
    },

    getValues: function () {
      const values = {};
      this.fields.forEach((field) => {
        const $field = jQuery(field);
        values[$field.attr("name")] = $field.val();
      });
      return values;
    },
  };

  instance.init(element);
  return instance;
};
